<template>
    <div :class="context.classes.element" :data-type="context.type">
        <input-now v-model="context.model" v-bind="attributes" v-on="$listeners" :context="context" />
        <FormulateSlot name="prefix" :context="context">
            <component :is="context.slotComponents.prefix" v-if="context.slotComponents.prefix" :context="context" />
        </FormulateSlot>

        <FormulateSlot name="suffix" :context="context">
            <component :is="context.slotComponents.suffix" v-if="context.slotComponents.suffix" :context="context" />
        </FormulateSlot>
    </div>
</template>

<script>
import FormulateInputMixin from "@braid/vue-formulate/src/FormulateInputMixin";
import InputNow from "@/components/InputNow.vue";

export default {
    name: "FormulateNow",
    mixins: [FormulateInputMixin],
    components: {
        InputNow,
    },
};
</script>
